import type { NearByV4Response } from "../__generated/api";

export async function fetchNearbySlots(
  params: Record<string, unknown>,
  restUrl: string,
): Promise<NearByV4Response[]> {
  const route = `v4/facilities/${String(params.facilityCode)}/nearby-slots`;
  const url = `${restUrl}${route}`;

  try {
    const response = await fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-Client-Application": process.env.APP_NAME ?? "Aspen Scheduler",
      },
      body: JSON.stringify(params),
    });

    if (!response.ok) {
      throw new Error(`POST: ${route} returned invalid status: ${response.status}`);
    }

    return response.json() as Promise<NearByV4Response[]>;
  } catch {
    return [];
  }
}
